"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVendorWords = exports.getVendorWordSingular = exports.getVendorWordSeoCategory = exports.getVendorWordPlural = exports.getVendorWordPill = exports.getVendorWordInstance = exports.getVendorWordCategory = void 0;
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
var _vendorTaxonomyKeys = require("./vendorTaxonomyKeys");
var _vendorUtils = require("./vendorUtils");
var _vendorWords;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Map that associates a vendor taxonomy key with an object of vendor words
 */
var vendorWords = (_vendorWords = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_vendorWords, _vendorTaxonomyKeys.ACCESSORIES_TAXONOMY_KEY, {
  singular: 'accessories',
  plural: 'accessories',
  instance: 'accessories',
  tracking: 'ACCESSORIES',
  category: 'Accessories',
  pill: 'Accessories'
}), _vendorTaxonomyKeys.ACCOMMODATIONS_TAXONOMY_KEY, {
  singular: 'accommodations',
  plural: 'accommodations',
  instance: 'accommodations',
  tracking: 'ACCOMMODATIONS',
  category: 'Accommodations',
  pill: 'Accommodations'
}), _vendorTaxonomyKeys.ALTERATIONS_PRESERVATION_TAXONOMY_KEY, {
  singular: 'alterations',
  plural: 'alterations',
  instance: 'alterations',
  tracking: 'ALTERATIONS_PRESERVATION',
  category: 'Alterations & Preservation',
  pill: 'Alterations'
}), _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY, {
  singular: 'musician',
  plural: 'musicians',
  instance: 'a musician',
  tracking: 'MUSICIAN_DJ',
  category: 'Bands & DJs',
  pill: 'Bands and DJs'
}), _vendorTaxonomyKeys.BAR_SERVICES_TAXONOMY_KEY, {
  singular: 'bar services & beverages',
  plural: 'bar services & beverages',
  instance: 'bar services & beverages',
  tracking: 'BAR_SERVICES',
  category: 'Bar Services & Beverages',
  pill: 'Bar and beverage'
}), _vendorTaxonomyKeys.BRIDAL_SHOPS_TAXONOMY_KEY, {
  singular: 'bridal shop',
  plural: 'bridal shops',
  instance: 'a bridal shop',
  tracking: 'BRIDAL_SHOP',
  category: 'Bridal Shops',
  pill: 'Bridal shops'
}), _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY, {
  singular: 'baker',
  plural: 'bakers',
  instance: 'a baker',
  tracking: 'BAKER',
  category: 'Cakes & Desserts',
  pill: 'Cakes and desserts'
}), _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY, {
  singular: 'caterer',
  plural: 'caterers',
  instance: 'a caterer',
  tracking: 'CATERER',
  category: 'Catering',
  pill: 'Catering'
}), _vendorTaxonomyKeys.CELEBRANTS_OFFICIANTS_TAXONOMY_KEY, {
  singular: 'officiant',
  plural: 'officiants',
  instance: 'an officiant',
  tracking: 'CELEBRANT_OFFICIANT',
  category: 'Celebrants & Officiants',
  pill: 'Officiants'
}), _vendorTaxonomyKeys.CHILDCARE_SERVICES_TAXONOMY_KEY, {
  singular: 'childcare services',
  plural: 'childcare services',
  instance: 'childcare services',
  tracking: 'CHILDCARE_SERVICES',
  category: 'Childcare Services',
  pill: 'Childcare services'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_vendorWords, _vendorTaxonomyKeys.CLOTHING_RENTALS_TAXONOMY_KEY, {
  singular: 'attire rentals',
  plural: 'attire rentals',
  instance: 'attire rentals',
  tracking: 'ATTIRE',
  category: 'Clothing Rentals',
  pill: 'Clothing rentals'
}), _vendorTaxonomyKeys.FLORISTS_TAXONOMY_KEY, {
  singular: 'florist',
  plural: 'florists',
  instance: 'a florist',
  tracking: 'FLORIST',
  category: 'Florists',
  pill: 'Florists'
}), _vendorTaxonomyKeys.GENERAL_SERVICES_TAXONOMY_KEY, {
  singular: 'general services',
  plural: 'general services',
  instance: 'general services',
  tracking: 'GENERAL_SERVICES',
  category: 'General Services',
  pill: 'General services'
}), _vendorTaxonomyKeys.GIFT_FAVORS_TAXONOMY_KEY, {
  singular: 'gifts & favors',
  plural: 'gifts & favors',
  instance: 'gifts & favors',
  tracking: 'GIFTS_FAVORS',
  category: 'Gifts & Favors',
  pill: 'Gifts and favors'
}), _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY, {
  singular: 'beauty professional',
  plural: 'beauty professionals',
  instance: 'a beauty professional',
  tracking: 'HAIR_MAKEUP',
  category: 'Beauty Professionals',
  pill: 'Beauty'
}), _vendorTaxonomyKeys.INVITATIONS_CALLIGRAPHY_TAXONOMY_KEY, {
  singular: 'calligrapher',
  plural: 'calligraphers',
  instance: 'a calligrapher',
  tracking: 'CALLIGRAPHER',
  category: 'Calligraphers',
  pill: 'Calligraphers'
}), _vendorTaxonomyKeys.JEWELERS_TAXONOMY_KEY, {
  singular: 'jewelry',
  plural: 'jewelry',
  instance: 'a jeweler',
  tracking: 'JEWELER',
  category: 'Jewelers',
  pill: 'Jewelers'
}), _vendorTaxonomyKeys.LIGHTING_AV_TAXONOMY_KEY, {
  singular: 'lighting',
  plural: 'lighting',
  instance: 'lighting',
  tracking: 'LIGHTING_AV',
  category: 'Lighting & AV',
  pill: 'Lighting and AV'
}), _vendorTaxonomyKeys.PHOTOBOOTHS_TAXONOMY_KEY, {
  singular: 'photo booth',
  plural: 'photo booths',
  instance: 'a photo booth',
  tracking: 'PHOTO_BOOTH',
  category: 'Photo Booths',
  pill: 'Photo booths'
}), _vendorTaxonomyKeys.PHOTOGRAPHERS_TAXONOMY_KEY, {
  singular: 'photographer',
  plural: 'photographers',
  instance: 'a photographer',
  tracking: 'PHOTOGRAPHER',
  category: 'Photographers',
  pill: 'Photographers'
}), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_vendorWords, _vendorTaxonomyKeys.PLANNERS_TAXONOMY_KEY, {
  singular: 'planner',
  plural: 'planners',
  instance: 'a wedding planner',
  tracking: 'PLANNER',
  category: 'Planners',
  pill: 'Planners'
}), _vendorTaxonomyKeys.SERVICE_STAFF_TAXONOMY_KEY, {
  singular: 'service staff',
  plural: 'service staff',
  instance: 'service staff',
  tracking: 'SERVICE_STAFF',
  category: 'Service Staff',
  pill: 'Service staff'
}), _vendorTaxonomyKeys.RENTALS_DECOR_TAXONOMY_KEY, {
  singular: 'decor',
  plural: 'decor',
  instance: 'decor',
  tracking: 'RENTAL_DECOR',
  category: 'Rentals & Decor',
  pill: 'Rentals and decor'
}), _vendorTaxonomyKeys.TRANSPORTATION_PROVIDERS_TAXONOMY_KEY, {
  singular: 'transportation',
  plural: 'transportation',
  instance: 'transportation',
  tracking: 'TRANSPORTATION',
  category: 'Transportation',
  pill: 'Transportation'
}), _vendorTaxonomyKeys.VARIETY_ACTS_TAXONOMY_KEY, {
  singular: 'entertainment',
  plural: 'entertainment',
  instance: 'entertainment',
  tracking: 'VARIETY_ACT',
  category: 'Variety Acts',
  pill: 'Variety acts'
}), _vendorTaxonomyKeys.VENUES_TAXONOMY_KEY, {
  singular: 'venue',
  plural: 'venues',
  instance: 'a venue',
  tracking: 'VENUE',
  category: 'Venues',
  pill: 'Venues'
}), _vendorTaxonomyKeys.VIDEOGRAPHERS_TAXONOMY_KEY, {
  singular: 'videographer',
  plural: 'videographers',
  instance: 'a videographer',
  tracking: 'VIDEOGRAPHER',
  category: 'Videographers',
  pill: 'Videographers'
}));
var defaultVendorWords = {
  singular: 'vendor',
  plural: 'vendors',
  instance: 'a vendor',
  tracking: 'VENDOR',
  category: 'Vendors',
  pill: 'Vendors'
};
var getVendorWords = exports.getVendorWords = function getVendorWords(vendorTaxonomyKey) {
  if (!vendorTaxonomyKey) {
    return defaultVendorWords;
  }
  return (0, _vendorUtils.getVendorTaxonomySwitchFunc)(vendorWords)(vendorTaxonomyKey);
};

/**
 * Get the singular name for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The singular name
 */
var getVendorWordSingular = exports.getVendorWordSingular = function getVendorWordSingular(categoryString) {
  return getVendorWords((0, _vendorUtils.getVendorTaxonomyKey)(categoryString)).singular;
};

/**
 * Get the plural name for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The plural name
 */
var getVendorWordPlural = exports.getVendorWordPlural = function getVendorWordPlural(categoryString) {
  return getVendorWords((0, _vendorUtils.getVendorTaxonomyKey)(categoryString)).plural;
};

/**
 * Get a phrase for an instance for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns A phrase for an instance, e.g. "a photographer"
 */
var getVendorWordInstance = exports.getVendorWordInstance = function getVendorWordInstance(categoryString) {
  return getVendorWords((0, _vendorUtils.getVendorTaxonomyKey)(categoryString)).instance;
};

/**
 * Get the capitalized category name for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The capitalized category name
 */
var getVendorWordCategory = exports.getVendorWordCategory = function getVendorWordCategory(categoryString) {
  return getVendorWords((0, _vendorUtils.getVendorTaxonomyKey)(categoryString)).category;
};

/**
 * Get the short-form category name for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The short-form category name
 */
var getVendorWordPill = exports.getVendorWordPill = function getVendorWordPill(categoryString) {
  return getVendorWords((0, _vendorUtils.getVendorTaxonomyKey)(categoryString)).pill;
};

/**
 * Get the capitalized SEO category name for a vendor category
 *
 * @param categoryString A vendor category string, which can be a taxonomy key, vendor type, or other category identifier
 * @returns The capitalized SEO category name
 */
var getVendorWordSeoCategory = exports.getVendorWordSeoCategory = function getVendorWordSeoCategory(categoryString) {
  var taxonomyKey = (0, _vendorUtils.getVendorTaxonomyKey)(categoryString);
  switch (taxonomyKey) {
    case _vendorTaxonomyKeys.BANDS_DJS_TAXONOMY_KEY:
      return 'DJs';
    case _vendorTaxonomyKeys.CAKES_DESSERTS_TAXONOMY_KEY:
      return 'Cake Bakeries';
    case _vendorTaxonomyKeys.CATERING_TAXONOMY_KEY:
      return 'Caterers';
    case _vendorTaxonomyKeys.HAIR_MAKEUP_TAXONOMY_KEY:
      return 'Hair & Makeup Artists';
    default:
      return getVendorWordCategory(categoryString);
  }
};